import { Link } from 'react-router-dom';

export default function SeoContent() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4">
              What Is Sugargoo Spreadsheet?
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
              Sugargoo Spreadsheet Makes Product Discovery{' '}
              <span className="text-primary-600 italic">Faster &amp; Smarter</span>
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                The <strong>Sugargoo Spreadsheet</strong> is a curated database designed to help shoppers
                discover trending products across multiple categories. Instead of scrolling through endless
                pages, users access organized product lists complete with pricing, images, and direct
                shopping links — all maintained and updated regularly by a community of passionate shoppers.
              </p>
              <p>
                Whether you are hunting for the latest sneaker releases, premium streetwear, unique
                accessories, or everyday essentials, the Sugargoo Spreadsheet consolidates everything
                into one accessible hub. Each entry includes verified product information, making it easier
                to compare options and make informed purchasing decisions without wasting hours on manual research.
              </p>
              <p>
                For both newcomers and experienced buyers, this resource dramatically reduces the time
                spent finding quality products. The structured format means you can jump straight to your
                preferred category — shoes, hoodies, jackets, bags, and more — and immediately browse
                dozens of handpicked items ready for purchase through Sugargoo.
              </p>
            </div>

            <div className="mt-8">
              <Link
                to="/article/sugargoo-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Read Complete Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8">
            <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-6">
              Traditional Searching vs Sugargoo Spreadsheet
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-200">
                    <th className="text-left py-3 pr-4 font-semibold text-foreground-800">Feature</th>
                    <th className="text-left py-3 pr-4 font-semibold text-foreground-400">Manual Search</th>
                    <th className="text-left py-3 font-semibold text-primary-600">Sugargoo Spreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { feature: 'Product Discovery', manual: 'Slow', sheet: 'Fast' },
                    { feature: 'Organization', manual: 'Messy', sheet: 'Structured' },
                    { feature: 'Finding Trends', manual: 'Difficult', sheet: 'Easy' },
                    { feature: 'Beginner Friendly', manual: 'No', sheet: 'Yes' },
                    { feature: 'Price Comparison', manual: 'Time-consuming', sheet: 'Instant' },
                    { feature: 'Updates', manual: 'Irregular', sheet: 'Daily' },
                  ].map((row) => (
                    <tr key={row.feature} className="border-b border-background-200/50">
                      <td className="py-3 pr-4 font-medium text-foreground-700">{row.feature}</td>
                      <td className="py-3 pr-4 text-foreground-500">{row.manual}</td>
                      <td className="py-3 text-primary-600 font-medium">{row.sheet}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}